import { whyChooseItems } from "@/mocks/siteData";

export default function AboutSection() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="w-full lg:w-5/12">
            <span className="inline-block text-xs font-medium text-foreground-500 tracking-widest uppercase mb-4">
              Why AcBuySpreadsheet
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-6">
              The Most Updated{" "}
              <span className="text-accent-500">Seller List</span>{" "}
              &amp; Buying Guide
            </h2>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8">
              Finding trusted products and reliable sellers in the fashion world can be difficult. Many seller lists become outdated within weeks, leaving buyers frustrated and overwhelmed. AcBuySpreadsheet solves this problem by providing a meticulously curated, weekly-updated spreadsheet that helps buyers discover the latest verified finds across all major fashion categories.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {whyChooseItems.map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <div className="w-5 h-5 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs text-accent-600"></i>
                  </div>
                  <span className="text-sm md:text-base text-foreground-700">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-7/12">
            <div className="grid grid-cols-5 gap-4 h-[400px] md:h-[500px]">
              <div className="col-span-2 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylish%20streetwear%20outfit%20with%20cargo%20pants%20and%20graphic%20tee%20on%20light%20concrete%20wall%20background%2C%20editorial%20fashion%20photography%2C%20soft%20urban%20daylight%2C%20modern%20minimalist%20composition%2C%20clean%20aesthetic&width=600&height=800&seq=about-v2-img-1&orientation=portrait"
                  alt="AcBuy Spreadsheet curated fashion finds"
                  title="AcBuy Spreadsheet Curated Fashion"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="col-span-3 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Complete%20fashion%20flatlay%20with%20sneakers%20denim%20jacket%20bag%20and%20accessories%20on%20light%20sand%20textured%20surface%2C%20editorial%20photography%2C%20natural%20morning%20light%2C%20minimalist%20style%2C%20harmonious%20composition&width=1000&height=800&seq=about-v2-img-2&orientation=landscape"
                  alt="AcBuy Spreadsheet complete fashion collection"
                  title="AcBuy Spreadsheet Streetwear Finds"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}